require('../scss/main.scss');
require('./Gallery');

import Shame from './Shame';
Shame();

import CookieConsent from './CookieConsent.js';
const cookieConsent = new CookieConsent({
    html: '<div id="cookie-info">\n' +
        '    <div class="cookie-info-wrapper u-ci-borderradius--large">\n' +
        '       <div class="container">\n' +
        '           <div class="cookie-info-content">\n' +
        '               <p class="cookie-info-text">\n' +
        '                   Wir möchten auf Basis Ihrer (jederzeit widerrufbaren) Einwilligung Cookies zum Zweck der Verbesserung unserer Website sowie Analyse Ihres Userverhaltens verwenden. Nähere Informationen finden Sie in unserer \n' +
        '                   <a href="/datenschutz">Datenschutzerklärung</a>\n' +
        '                   </p>\n' +
        '           <div class="cookie-info-buttons">\n' +
        '                   <button id="cookie-alert-accept" class="btn btn--internal" ><span>Ich stimme zu</span></button>\n' +
        '                   <button id="cookie-alert-decline" class="cookie-hide" ><span class="u-sr-only">schließen</span></button>\n' +
        '               </div>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '</div>',
    onAccepted: function(){
        window._paq = window._paq || [];
        window._paq.push(['trackPageView']);
        window._paq.push(['enableLinkTracking']);

        (function() {
            var u = document.querySelector('meta[name="matomo-url"]').content;
            var trackingId = document.querySelector('meta[name="matomo-id"]').content;
            window._paq.push(['setTrackerUrl', u+'matomo.php']);
            window._paq.push(['setSiteId', trackingId]);

            var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
            g.type='text/javascript'; g.async=true; g.defer=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
        })();
    }
});
cookieConsent.check();

import SearchField from './SearchField';
SearchField();

import Navigation from './Navigation';
Navigation();

require('./Slider');